<template>
  <div class="floating-dropdown">
    <button
      ref="toggle"
      class="floating-dropdown__toggle"
      @click="toggle"
      :class="[
        this.open ? 'floating-dropdown__toggle--open' : '',
      ]"
    >
      <slot name="toggle"/>
    </button>

    <transition name="floating-dropdown__dropdown-">
      <div
        v-if="open"
        :style="{right: `${rightOffset}px`}"
        class="floating-dropdown__dropdown"
        v-on-clickaway="away"
      >
        <slot/>
      </div>
    </transition>
  </div>
</template>

<script>
  import {mixin as clickaway} from 'vue-clickaway';

  export default {
    mixins: [clickaway],
    props: {
      open: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        rightOffset: 0,
      }
    },
    watch: {
      open() {
        this.updateRightOffset();
      },
    },
    methods: {
      toggle() {
        if (this.open) {
          this.$emit('close');
        } else {
          this.updateRightOffset();
          this.$emit('open');
        }
      },
      away() {
        if (this.open && this.external) {

        }
      },
      updateRightOffset() {
        const screeWidth = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
        const dropdownWidth = 352;
        const margin = 8;

        if (screeWidth < dropdownWidth + margin * 2) {
          return margin;
        }

        const toggle = this.$refs.toggle;
        const toggleCenterFromRight = screeWidth - toggle.offsetLeft - toggle.offsetWidth / 2;

        this.rightOffset = Math.max(toggleCenterFromRight - dropdownWidth / 2, margin);
      },
    },
    mounted() {
      this.updateRightOffset();
      window.addEventListener('resize', this.updateRightOffset);
    },
    destroyed() {
      window.removeEventListener('resize', this.updateRightOffset);
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .floating-dropdown {
    position: relative;
  }

  .floating-dropdown__dropdown {
    position: absolute;
    overflow: hidden;
    width: r(352);
    max-width: calc(100vw - #{r(16)});
    background-color: $color-white;
    box-shadow: 0 r(2) r(4) 0 rgba(0, 0, 0, 0.5);
    border-radius: r(2);
    transition: opacity 0.2s, transform 0.2s;
    right: 0 !important;

    &--enter,
    &--leave-to {
      opacity: 0;
      transform: translateY(r(-8));
    }
  }

  .floating-dropdown__toggle {
    @include reset-button(true);

    &--open {
      background-color: $white !important;
    }
  }
</style>
